import React from 'react'
import MainSection from '../components/PrivacyPolicy/MainSection'
import PrivacyPolicy from '../components/PrivacyPolicy/PrivacyPolicy'

const PrivacyPolicyPage = () => {
  return (
    <>
        <MainSection/>
        <PrivacyPolicy/>
    </>
  )
}

export default PrivacyPolicyPage